import { FirebaseService } from './firebase.service';

export default angular
  .module('sfMobile.services.firebase', ['sfMobile.config.server'])
  .service('firebaseService', FirebaseService).name;
